export default "__VITE_ASSET__CWvFDVBo__"